export default import.meta.ROLLDOWN_FILE_URL_IHP9rAr2H5J2loOiF4uFhw